var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAction3DReliefColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1064 20H1.76367L7.31738 8.89258L9.43457 10.5869L10.2295 7.94238L14.627 3.54492L22.1064 20Z",
    fill: "url(#paint0_linear_1102_12204)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L10.5 14L8 12L5 18H19L14 7L12 9Z",
    fill: "url(#paint1_linear_1102_12204)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18H15.792L13.5859 7.41309L14 7L19 18Z",
    fill: "url(#paint2_linear_1102_12204)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14L9 16L8 12L10.5 14Z",
    fill: "url(#paint3_linear_1102_12204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1102_12204",
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37FE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1102_12204",
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C75E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1102_12204",
    x1: 14.75,
    y1: 7,
    x2: 14.75,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1102_12204",
    x1: 14.75,
    y1: 7,
    x2: 14.75,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAction3DReliefColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_3d_relief_colored_day.01968be8566683da58aac587abd541c0.svg";
export { ForwardRef as ReactComponent };